import React from 'react';
import { Shield, Server, Cloud, Monitor, Search, Users, Settings, Workflow } from 'lucide-react';

import Header from './header';
import Footer from './footer';


export default function ECMSoftwarePage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-900 to-slate-800">
      <Header/>

      {/* Hero Section */}
      <section className="relative overflow-hidden py-20 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-3xl lg:text-5xl font-bold text-white mb-6">
                Document Management System (DMS) 
              </h1>
              <div className="w-16 h-1 bg-red-500 mx-auto lg:mx-0 mb-8"></div>
              <p className="text-xl text-blue-100 leading-relaxed">
                Take control of digital through which all types of data in all the information you need. Discover a new co-way with your daily client and easy-to-use Corporate Document Management (DMS) software, that can help you have the software you need. You will also have a part of housekeeping and page as well consumers mainly in areas of your questions and what you find the best solution for your business.
              </p>
            </div>
            
            {/* Isometric Illustration */}
            <div className="relative">
              <div className="relative w-full h-96 perspective-1000">
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="relative transform-gpu">
                    {/* Main Server */}
               

                  

             

                    {/* Video Element */}
                    <div className="w-full h-full rounded-xl overflow-hidden shadow-2xl border-2 border-cyan-400">
                      <video 
                        className="w-full h-full object-cover"
                        autoPlay
                        muted
                        loop
                        playsInline
                      >
                        <source src="./DMS.mp4" type="video/mp4" />
                       {/* <source src="./DMS.mp4" type="video/mp4" /> */}
                         Your browser does not support the video tag.
                      </video>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-blue-100 text-lg mb-8 max-w-4xl mx-auto">
              Learn about the benefits of our software and must assume it and access to you antelis customers, see if it can help
              you antelis customers, see if it can help you as business and as a Software Service Your Account.
            </p>
            <p className="text-blue-100 text-lg max-w-4xl mx-auto">
              Your old-school business has begun to depend on one software so do its the customers. However, so far free using creating first, safely advises and
              quality of DMS software is one sight doing better. If you are looking for software using one time and safety advises, so for the business guide you through your business
              at. Decrease not take this remaining understand the value requirements of your business control you are working to find for the best customer. Without even
              transforming software and site expense not optimize your processes, including among top and increasing quality.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Advanced Search */}
            <div className="bg-gradient-to-br from-cyan-500 to-blue-600 rounded-2xl p-8 text-white relative overflow-hidden">
              <div className="absolute bottom-0 right-0 text-6xl font-bold opacity-10">01</div>
              <Search className="w-8 h-8 mb-4 text-cyan-100" />
              <h3 className="text-xl font-bold mb-6">Advanced Search</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>OCR & Intelligent Indexing</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Lightning-Fast Search</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Advanced Query Builder</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Full-Text Document Search</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Smart Tag Recognition</li>
              </ul>
            </div>

            {/* Document Organization */}
            <div className="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl p-8 text-white relative overflow-hidden">
              <div className="absolute bottom-0 right-0 text-6xl font-bold opacity-10">02</div>
              <Monitor className="w-8 h-8 mb-4 text-purple-100" />
              <h3 className="text-xl font-bold mb-6">Smart Organization</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Intuitive Drag & Drop</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Centralized Repository</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Automated File Import</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Dynamic Categorization</li>
              </ul>
            </div>

            {/* Team Collaboration */}
            <div className="bg-gradient-to-br from-emerald-500 to-teal-600 rounded-2xl p-8 text-white relative overflow-hidden">
              <div className="absolute bottom-0 right-0 text-6xl font-bold opacity-10">03</div>
              <Users className="w-8 h-8 mb-4 text-emerald-100" />
              <h3 className="text-xl font-bold mb-6">Team Collaboration</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Version Control System</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Real-time Collaboration</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Secure File Sharing</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Permission Management</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Electronic Security</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Offline Accessibility</li>
              </ul>
            </div>

            {/* Workflow Automation */}
            <div className="bg-gradient-to-br from-orange-500 to-red-600 rounded-2xl p-8 text-white relative overflow-hidden">
              <div className="absolute bottom-0 right-0 text-6xl font-bold opacity-10">04</div>
              <Workflow className="w-8 h-8 mb-4 text-orange-100" />
              <h3 className="text-xl font-bold mb-6">Workflow Automation</h3>
              <ul className="space-y-3 text-sm">
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Custom Process Builder</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Advanced Security Protocols</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Intelligent Routing</li>
                <li className="flex items-center"><span className="w-2 h-2 bg-white rounded-full mr-3"></span>Automated Archives</li>
              </ul>
              <div className="mt-6 grid grid-cols-2 gap-2 text-xs">
                <div className="space-y-1">
                  <div>API Integration</div>
                  <div>Process Mining</div>
                  <div>Business Rules</div>
                  <div>Custom Scripts</div>
                </div>
                <div className="space-y-1">
                  <div>Analytics</div>
                  <div>Reporting</div>
                  <div>Mobile Apps</div>
                  <div>Email Sync</div>
                  <div>Dashboard</div>
                  <div>Compliance</div>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <p className="text-blue-100 text-lg max-w-4xl mx-auto mb-8">
              Experience the power of intelligent document management with Anvitech's comprehensive DMS solution. Our platform 
              delivers personalized implementation strategies, expert consultation, and ongoing support to ensure your digital 
              transformation success.
            </p>
            <p className="text-blue-100 text-lg max-w-4xl mx-auto mb-8">
              Ready to revolutionize your document management approach? Discover how Anvitech's DMS software can streamline 
              your operations, enhance security, and drive productivity across your organization. Contact our specialists today 
              for a personalized consultation and see the difference our technology can make.
            </p>
               <button onClick={() => window.location.href = '/Contact'} className="bg-gradient-to-r from-cyan-500 to-blue-600 hover:from-cyan-600 hover:to-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1">
              Start Your Digital Transformation
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <Footer/>
    </div>
  );
}